import { ConfigurationSource } from './StartFromStep';

const configurationSources: ConfigurationSource[] = ['blank', 'preset', 'previousJob'];

export const isConfigurationSource = (value: unknown): value is ConfigurationSource =>
  configurationSources.includes(value as ConfigurationSource);

export const getInitialConfigurationSource = ({
  jobId,
  persistedConfigurationSource,
}: {
  jobId?: string;
  persistedConfigurationSource?: string;
}): ConfigurationSource =>
  jobId ? 'previousJob' : isConfigurationSource(persistedConfigurationSource) ? persistedConfigurationSource : 'blank';
